'use client'
import { InfoTooltip } from '@morpho-org/ui-v6/client'
import { memo, type PropsWithChildren } from 'react'

export const VaultRiskDisclosuresLayout = memo(({ children }: PropsWithChildren) => {
  return (
    <div
      className="gap-sm flex w-full scroll-mt-[calc(var(--sticky-offset,0px)+16px)] flex-col"
      id="risk-disclosures-section"
      data-testid="vault-v1-risk-disclosures"
    >
      <div className="gap-xs flex items-center">
        <span className="text-foreground text-sm">Risk Disclosures</span>
        <InfoTooltip
          tooltipContent={
            <>
              Shared by the curator, this section outlines the risks associated with the markets the
              vault allocates to and their configuration.
            </>
          }
        />
      </div>
      {children}
    </div>
  )
})

VaultRiskDisclosuresLayout.displayName = 'VaultRiskDisclosuresLayout'
